// export let OrganizationModalLayoutJSON = [
//   {
//     name: "New",
//     child: [
//       {
//         parentid: "section-1719383677777-form",
//         elementid: "1719383687656",
//         elementtype: "textfield",
//       },
//       {
//         parentid: "section-1719383677777-form",
//         elementid: "1719383709240",
//         elementtype: "phoneNumber",
//       },
//       {
//         parentid: "section-1719383677777-form",
//         elementid: "1719383715621",
//         elementtype: "textfield",
//       },
//       {
//         parentid: "section-1719383677777-form",
//         elementid: "1719383722105",
//         elementtype: "customSelect",
//       },
//     ],
//     parentid: "myTabContent",
//     elementid: "section-1719383677777",
//     description: "",
//     elementtype: "section",
//     "section-type": "form",
//     linkedentitytype: -1,
//   },
// ];

export let OrganizationModalLayoutJSON = [
  {
    name: "New",
    child: [
      {
        child: [
          {
            child: [
              {
                parentid: "1719383677777-col-1",
                elementid: "1719383687656",
                elementtype: "textfield",
              },
              {
                parentid: "1719383677777-col-1",
                elementid: "1719383709240",
                elementtype: "phoneNumber",
              },
              {
                parentid: "1719383677777-col-1",
                elementid: "1719383687657",
                elementtype: "textfield",
              },
              {
                parentid: "1719383677777-col-1",
                elementid: "1719383687661",
                elementtype: "textfield",
              },
              {
                parentid: "1719383677777-col-1",
                elementid: "1719383687659",
                elementtype: "number",
              },
              {
                parentid: "1692362019775-col-2",
                elementid: "1719383687660",
                elementtype: "textarea",
              },
            ],
            colpos: 1,
            parentid: "1719383677777-columns",
            elementid: "1719383677777-col-1",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
          {
            child: [
              {
                parentid: "1692362019775-col-2",
                elementid: "1719383715621",
                elementtype: "email",
              },
              {
                parentid: "1692362019775-col-2",
                elementid: "1719383722105",
                elementtype: "customSelect",
              },
              {
                parentid: "1692362019775-col-2",
                elementid: "1719383687658",
                elementtype: "textfield",
              },
              {
                parentid: "1692362019775-col-2",
                elementid: "1719383687662",
                elementtype: "textfield",
              },
              {
                parentid: "1719383677777-col-1",
                elementid: "1719383687663",
                elementtype: "textfield",
              },
            ],
            colpos: 2,
            parentid: "1692362019775-columns",
            elementid: "1692362019775-col-2",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
        ],
        colsize: 2,
        parentid: "section-1692362014074-form",
        elementid: "1692362019775",
        elementtype: "columns",
      },
    ],
    parentid: "myTabContent",
    elementid: "section-1692362014074",
    description: "",
    elementtype: "others",
    "section-type": "form",
    linkedentitytype: -1,
  },
];
